import React from "react";
import { IconX } from "@tabler/icons";
import cn from "classnames";
import { useAsyncDebounce, TableInstance } from "react-table";

export type GlobalFilterProps<T extends object> = TableInstance<T>;

export const GlobalFilter = <T extends object>(props: GlobalFilterProps<T>) => {
  const {
    state: { globalFilter },
    setGlobalFilter,
  } = props;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <div className="ms-auto text-muted">
      Search:
      <div className="ms-2 d-inline-block">
        <div className="input-group input-group-flat">
          <input
            type="text"
            value={value || ""}
            className="form-control"
            autoComplete="off"
            onChange={(e) => {
              setValue(e.target.value);
              onChange(e.target.value);
            }}
            aria-label="Global table filter"
          />
          {value && (
            <span className="input-group-text">
              <a
                onClick={() => {
                  setValue(undefined);
                  setGlobalFilter(undefined);
                }}
                className={cn("link-secondary", { disabled: !globalFilter })}
                title=""
                data-bs-toggle="tooltip"
                data-bs-original-title="Clear search"
              >
                <IconX />
              </a>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default GlobalFilter;
